import {Component, Inject, Input, LOCALE_ID, OnChanges} from '@angular/core';

@Component({
  selector: 'app-credit-addons',
  templateUrl: './credit-addons.component.html',
  styleUrls: ['./credit-addons.component.scss'],
  standalone: false,
})
export class CreditAddonsComponent implements OnChanges {
  @Input() public aiCredits = 0;

  public aiCreditsFormatted: string | null = null;

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  ngOnChanges(): void {
    this.aiCreditsFormatted = this.aiCredits.toLocaleString('nl-NL', {
      maximumFractionDigits: 0,
    });
  }
}
